module.exports = __webpack_public_path__ + "img/11-min.bd968488.jpg";